import { LogoutOutlined } from "@ant-design/icons";
import { useLazyQuery, useMutation, useQuery } from "@apollo/react-hooks";
import {
  Button,
  Col,
  Form,
  message,
  Row,
  Select,
  Table,
  Typography,
} from "antd";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Loader } from "../../../../Components/Loader";
import { SuccessModal } from "../../../../Components/Modals/SuccessModal";
import { SkipButton } from "../../../../Components/SkipButton";
import { CustIcon } from "../../../../Components/Svgs";
import {
  DELETE_REMOVED_EMP_REPORTEE,
  INSERT_EMPLOYEE_REPORTING,
} from "../../../../Graphql/mutations";
import {
  GET_EMPLOYEES_BY_LOCATION,
  GET_EMPLOYEE_REPORTING_LIST_FOR_TABLE,
  GET_OWNER_LOCATIONS,
} from "../../../../Graphql/queries";
import { logout } from "../../../../Utils/functions/common";
import "./EmployeeReportingManagement.less";

const { Option } = Select;
const { Title } = Typography;
// const { Column } = Table;
const layout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

export const EmployeeReportingManagement = (props) => {
  const user_id = localStorage.getItem("user_id");
  const history = useHistory();
  const [locationId, setLocationId] = useState(null);
  const [reportingToList, setReportingToList] = useState([]);
  const [reporteeList, setReporteeList] = useState([]);
  const [businessLocationIds, setBusinessLocationIds] = useState([]);
  const [reportingTo, setReportingTo] = useState("");
  const [accessTypes, setAccessTypes] = useState(["1", "2", "3", "4"]);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [form] = Form.useForm();

  const { data: businessLocations, loading: businessLocationsLoading } =
    useQuery(GET_OWNER_LOCATIONS, {
      variables: { user_id: user_id },
      fetchPolicy: "cache-and-network",
    });

  //To display list of employee reporting below
  const [
    GET_EMPLOYEE_REPORTING_LIST_FOR_TABLE_QUERY,
    { data: empReportingList, loading: empReportingListLoading, refetch },
  ] = useLazyQuery(GET_EMPLOYEE_REPORTING_LIST_FOR_TABLE, {
    variables: { locationIds: businessLocationIds },
    fetchPolicy: "cache-and-network",
  });

  //To get the employees list of selected location for reportingTo dropdown
  const [
    GET_EMPLOYEES_FOR_REPORTINGTO_BY_LOCATION_QUERY,
    { data: reportingToUsers, loading: reportingToUsersLoading },
  ] = useLazyQuery(GET_EMPLOYEES_BY_LOCATION, {
    variables: { location_id: locationId, access_type_id_nums: accessTypes },
    fetchPolicy: "cache-and-network",
  });

  //To get the employees list of selected location for reportee dropdown
  const [
    GET_EMPLOYEES_FOR_REPORTEE_BY_LOCATION_QUERY,
    { data: reporteeToUsers, loading: reporteeUsersLoading },
  ] = useLazyQuery(GET_EMPLOYEES_BY_LOCATION, {
    variables: { location_id: locationId, access_type_id_nums: accessTypes },
    fetchPolicy: "cache-and-network",
  });

  const [
    DELETE_REMOVED_EMP_REPORTEE_MUTATION,
    { loading: deletingEmpReportee },
  ] = useMutation(DELETE_REMOVED_EMP_REPORTEE);

  //To insert or update employee reporting data
  const [
    INSERT_EMPLOYEE_REPORTING_MUTATION,
    { loading: insertEmpReportingLoading },
  ] = useMutation(INSERT_EMPLOYEE_REPORTING);

  useEffect(() => {
    if (businessLocations) {
      const locationIds = businessLocations?.location.map((x) => x.location_id);
      setBusinessLocationIds(locationIds);
      GET_EMPLOYEE_REPORTING_LIST_FOR_TABLE_QUERY({
        variables: { locationIds: locationIds },
      });
    }
  }, [businessLocations]);

  useEffect(() => {
    if (reportingToUsers && !reportingToUsersLoading) {
      let reportingToList = [];
      reportingToUsers?.usersData?.empData.forEach((obj) => {
        reportingToList.push({
          id: obj.userDetails.user_id,
          name: obj.userDetails.first_name + " " + obj.userDetails.last_name,
          type_id: obj.roleData.accessDetails.type_id,
        });
      });
      setReporteeList([]);
      setReportingToList(reportingToList);
    }
  }, [reportingToUsers, reportingToUsersLoading]);

  useEffect(() => {
    if (reporteeToUsers && !reporteeUsersLoading) {
      let reporteeList = [];
      reporteeToUsers?.usersData?.empData.forEach((obj) => {
        reporteeList.push({
          id: obj.userDetails.user_id,
          name: obj.userDetails.first_name + " " + obj.userDetails.last_name,
          type_id: obj.roleData.accessDetails.type_id,
        });
      });

      //Logic for bydefault set reportee list checked
      let existingReporteeList = [];
      if (empReportingList && empReportingList?.usersData) {
        empReportingList &&
          empReportingList?.usersData.map((user) => {
            const existingReportee = reporteeList.find(
              (x) =>
                user.location_details?.location_id === locationId &&
                x.id === user.reportee_details?.user_id &&
                user.reporter_details?.user_id === reportingTo
            );
            if (existingReportee) {
              existingReporteeList.push(existingReportee.id);
            }
          });
      }

      setReporteeList(reporteeList);
      form.setFieldsValue({
        ["reportee"]: existingReporteeList,
      });
    }
  }, [reporteeToUsers, reporteeUsersLoading]);

  const onLocationChange = (location_id) => {
    setLocationId(location_id);
    form.setFieldsValue({
      ["reportingTo"]: "",
      ["reportee"]: [],
    });
    GET_EMPLOYEES_FOR_REPORTINGTO_BY_LOCATION_QUERY({
      variables: {
        location_id: location_id,
        access_type_id_nums: ["1", "2", "3", "4"],
      },
    });
  };

  const onReportingToChange = (reportingToId, event) => {
    if (event) {
      setReportingTo(reportingToId);
      const type_id = event.key;
      let accessTypesData = [];
      if (type_id) {
        accessTypesData = Array.from({ length: 5 }, (_, i) => i + 1).filter(
          (val) => val > parseInt(type_id)
        );
        accessTypesData = accessTypesData.map(String);
      }
      GET_EMPLOYEES_FOR_REPORTEE_BY_LOCATION_QUERY({
        variables: {
          location_id: locationId,
          access_type_id_nums: accessTypesData,
        },
      });
    }
  };

  const onFinish = async (values) => {
    const isDeleteSuccess = await deleteRemovedReportee(values);
    const isInsertSuccess = await insertReportee(values);

    if (isDeleteSuccess && isInsertSuccess) {
      setShowSuccessModal(true);
      form.resetFields();
    }
  };

  const deleteRemovedReportee = async (values) => {
    let deletedReporteeList = [];
    if (empReportingList && empReportingList?.usersData) {
      deletedReporteeList = _.compact(
        empReportingList?.usersData.map((x) => {
          if (
            !values.reportee.includes(x.reportee_details?.user_id) &&
            x.reporter_details?.user_id === values.reportingTo
          )
            return x.reportee_details?.user_id;
        })
      );
    }

    if (deletedReporteeList.length !== 0) {
      let requestParams = {
        location_id: values.location,
        reportee_ids: deletedReporteeList,
        reporter_id: values.reportingTo,
      };

      try {
        const result = await DELETE_REMOVED_EMP_REPORTEE_MUTATION({
          variables: requestParams,
        });
        if (!result.errors) {
          refetch();
          return true;
        } else {
          return false;
        }
      } catch (error) {
        message.error("Something went wrong...");
        return false;
      }
    } else {
      return true;
    }
  };

  const insertReportee = async (values) => {
    let reporteeDataListToInsert = [];

    if (empReportingList && empReportingList?.usersData) {
      values.reportee?.map((reportee_id) => {
        if (
          !empReportingList?.usersData?.find(
            (x) =>
              x.location_details?.location_id === locationId &&
              x.reportee_details?.user_id === reportee_id &&
              x.reporter_details?.user_id === values.reportingTo
          )
        ) {
          reporteeDataListToInsert.push(reportee_id);
        }
      });
    } else {
      reporteeDataListToInsert = values.reportee;
    }

    let requestParams = reporteeDataListToInsert.flatMap((reportee_id) => [
      {
        location_id: values.location,
        reportee_id: reportee_id,
        reporter_id: values.reportingTo,
      },
    ]);

    try {
      const result = await INSERT_EMPLOYEE_REPORTING_MUTATION({
        variables: {
          objects: requestParams,
        },
      });
      if (!result.error) {
        GET_EMPLOYEE_REPORTING_LIST_FOR_TABLE_QUERY({
          variables: { locationIds: businessLocationIds },
        });
        refetch();
        return true;
      }
      return false;
    } catch (error) {
      message.error("Something went wrong...");
      return false;
    }
  };

  const onContinue = () => {
    history.push("/");
  };

  return (
    <div className="onBoardingRight">
      <div className="employeeReporting">
        <div className="pl-lg-5">
          <div className="d-flex justify-content-between align-items-start">
            <Title level={2}>
              <CustIcon type="left-arrow" onClick={() => history.goBack()} />
              Setup Employee Reporting
            </Title>
            <div
              className="d-flex align-items-center cursorPointer"
              onClick={() => logout()}
            >
              <LogoutOutlined />
              <span className="pl-2">Logout</span>
            </div>
          </div>
          <p className="subTitle">
            Select employee and their reporting from below.
          </p>
        </div>

        <Form
          form={form}
          {...layout}
          id="empReportingForm-form"
          name="empReportingForm"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
        >
          <Row gutter={16}>
            <Col xs={24} md={12} lg={7}>
              <Col span={24}>
                <label className="mb-2">Select location</label>
              </Col>
              <Form.Item
                shouldUpdate
                htmlFor="location"
                name="location"
                rules={[
                  {
                    required: true,
                    message: "Select location.",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Location"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={(e) => onLocationChange(e)}
                >
                  {businessLocations?.location.map((d) => (
                    <Option key={d.location_id}>
                      {d.locationDetails.location_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={7}>
              <Col span={24}>
                <label className="mb-2">Reporting to</label>
              </Col>
              <Form.Item
                shouldUpdate
                htmlFor="reportingTo"
                name="reportingTo"
                rules={[
                  {
                    required: true,
                    message: "Select reporting to.",
                  },
                ]}
              >
                <Select
                  showSearch
                  name="reportingTo"
                  placeholder="Reporting to"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  onSelect={(value, e) => onReportingToChange(value, e)}
                >
                  {reportingToList.map((d) => (
                    <Option key={d.type_id} value={d.id}>
                      {d.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={7}>
              <Col span={24}>
                <label className="mb-2">Reportee</label>
              </Col>
              <Form.Item
                shouldUpdate
                htmlFor="reportee"
                name="reportee"
                rules={[
                  {
                    required: true,
                    message: "Select reportee.",
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  maxTagCount={1}
                  showSearch
                  name="reportee"
                  placeholder="Reportee"
                  className="reporteeSelect"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {reporteeList.map((d) => (
                    <Option key={d.id}>{d.name}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={12} lg={3}>
              <Col span={24}>
                <label className="mb-2 d-md-inline-block d-none"></label>
              </Col>
              <Form.Item className="buttonSec text-center pt-2">
                <Button
                  type="primary"
                  shape="round"
                  size="large"
                  htmlType="submit"
                  disabled={
                    !form.isFieldsTouched(false) ||
                    form.getFieldsError().filter(({ errors }) => errors.length)
                      .length > 0
                  }
                >
                  Submit
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        {empReportingListLoading ? (
          <Loader />
        ) : (
          empReportingList && (
            <div className="importDatdaTable px-2 w-100">
              <h6 className="text-dark">Employee List</h6>
              <EmpDataTable data={empReportingList?.usersData} />
            </div>
          )
        )}
        <Form.Item className="buttonSec text-center pt-3 mb-0">
          <SkipButton />
          <Button
            type="primary"
            shape="round"
            size="large"
            htmlType="submit"
            onClick={onContinue}
          >
            Continue
          </Button>
        </Form.Item>
      </div>
      {showSuccessModal && (
        <SuccessModal closeModal={() => setShowSuccessModal(false)} />
      )}
    </div>
  );
};

const EmpDataTable = (data) => {
  const columns = [
    {
      title: "Code",
      key: "code",
      width: 100,
      render: (status, record) => {
        return <span>{record.reportee_details.employee_code}</span>;
      },
    },
    {
      title: "Name",
      key: "name",
      width: 100,
      render: (status, record) => {
        return (
          <span>
            {record.reportee_details.first_name +
              " " +
              record.reportee_details.last_name}
          </span>
        );
      },
    },
    {
      title: "Reporting to",
      key: "reporting_to_name",
      width: 100,
      render: (status, record) => {
        return (
          <span>
            {record.reporter_details.first_name +
              " " +
              record.reporter_details.last_name}
          </span>
        );
      },
    },
    {
      title: "Location",
      key: "location",
      width: 100,
      render: (status, record) => {
        return <span>{record.location_details.location_name}</span>;
      },
    },
  ];

  return <Table columns={columns} dataSource={data?.data} rowKey="id" />;
};
